const customTitleBarStyle = theme => ({
    auto: { width: 'auto' },
    statusButton: { marginLeft: theme.spacing(2) },
    action: { textAlign: 'end' },
});

export default customTitleBarStyle;
